import { Expose } from "class-transformer";
import { IsNumber, IsString } from "class-validator";

export class BankStatementParser {
  @IsNumber()
  @Expose()
  id!: number;
  @IsNumber()
  @Expose()
  bankStatementType!: number;
  @IsString()
  @Expose()
  fileType!: string;
  @IsString()
  @Expose()
  fileFilter!: string;
  @IsString()
  @Expose()
  name!: string;
}
